<template>
  <div id="main-content">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row class="row-section">
        <input type="file" ref="file" @change="onChange" accept=".csv" />
        <el-button type="primary" @click="importFile" :disabled="!file">{{ $t('common.import') }}</el-button>
        <el-button type="success" @click="retrieveSampleFile">{{ $t('common.get_sample_file') }}</el-button>
      </el-row>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "PlaceImport",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/place?action=back`,
        title: 'common.import',
        file: null
      }
    },
    methods: {
      importFile: function () {
        let data = new FormData()
        data.append('file', this.file)

        let payload = {
          data,
          successCallback: () => {
            this.$refs.file.value = ''
            this.file = null
          }
        }

        this.$store.dispatch('place/importPlaces', payload)
      },
      retrieveSampleFile: function () {
        let payload = {
          successCallback: (response) => {
            let link = document.createElement('a')
            link.download = 'place_csv.csv'
            link.href = response.data.data.url
            link.click()
            link.remove()
          }
        }

        this.$store.dispatch('place/retrieveSamplePlaceFile', payload)
      },
      onChange: function () {
        if (this.$refs.file.files.length) {
          this.file = this.$refs.file.files[0]
        } else {
          this.file = null
        }
      }
    }
  }
</script>

<style lang="scss">

</style>